import React from 'react';
import { observer } from 'mobx-react-lite';
import { Alert, Box, Typography } from '@mui/material';
import UserAddressOption from '../models/UserAddressOption';

interface UserAddressInfoProps {
    userAddressOption: UserAddressOption
}

const UserAddressInfo: React.FC<UserAddressInfoProps> = observer(({ userAddressOption }) => {

    var titleText = userAddressOption === "new" ? "Ovu adresu nećemo spremiti." : "Ovu adresu ćemo spremiti.";
    var descriptionText = userAddressOption === "new" ? "Iskoristi je samo za ovu narudžbu." : `Prilikom sljedeće narudžbe možeš je upotrijebiti klikom na "${resolveUserAddressOption(userAddressOption)}".`
    return (
        <Alert severity="info">
             <Typography variant='subtitle2'>{titleText}</Typography>
             <Typography variant='caption'>{descriptionText}</Typography>
        </Alert>
    )
})

export default UserAddressInfo;

const resolveUserAddressOption = (userAddressOption: UserAddressOption) => {
    if (userAddressOption === "home") {
        return "Kuća";
    } else if (userAddressOption === "work") {
        return "Posao";
    } else if (userAddressOption === "other") {
        return "Drugo";
    }
}